import React, { useCallback } from 'react';

export const useEffectBlockFirstLoad = (cb, dependencies) => {
  const firstLoadRef = React.useRef(false);
  const stringDependencies = dependencies.map((n) => (typeof n === 'function' ? n : JSON.stringify(n)));
  const stabilizedFunction = useCallback(cb, stringDependencies);
  React.useEffect(() => {
    if (!firstLoadRef.current) {
      firstLoadRef.current = true;
      return;
    }
    stabilizedFunction();
  }, [stabilizedFunction]);
};

export default useEffectBlockFirstLoad;
